import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import style from '../helpers/MultiselectItem/style.module.css';

const TagComponent = ({ value = '', id, exclude = false, index, onRemoveTag, onChangeStatus, disableStatusChange }) => {
  const tagClassName = classNames(style.host, { [style.exclude]: exclude, [style.disabled]: disableStatusChange });
  const handleChangeStatus = disableStatusChange ? undefined : () => onChangeStatus(index, id);

  return (
    <div className={tagClassName} onClick={handleChangeStatus}>
      {value}
      {onRemoveTag && (
        <button
          aria-hidden="true"
          aria-label="close"
          className={classNames(style.close, 'close btn-xs')}
          name={`tag${index}`}
          onClickCapture={event => onRemoveTag(event, id)}
          type="button"
        >
          &times;
        </button>
      )}
    </div>
  );
};

TagComponent.propTypes = {
  disableStatusChange: PropTypes.bool,
  exclude: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onChangeStatus: PropTypes.func,
  onRemoveTag: PropTypes.func,
  value: PropTypes.any,
};

/** Tag component. */
export const Tag = memo(TagComponent);
